module.exports = ".gsa-configuration .mat-form-field-wrapper{display:flex}\n"